<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  beforeCreate() {
    if (this.$route.path != "/home" && this.$route.path != "/login-index") {
      // this.$router.replace("/home");
    }
  },
  created() {
    this.modelChange()
  },
  methods: {
    // 使用方法
    async modelChange() {
      let detail = await this.service.systemSettings.PlatformSetting({
        pageNo: 1,
        pageSize: 10,
        dictType: "9",
      });
      if (detail.code == 0) {
        document.title = detail.data[0].fullName + "后台管理";
        configureInfos.name = detail.data[0].fullName + " - 后台管理";
        configureInfos.domainName = detail.data[0].domain;
        configureInfos.OSSDomain = detail.data[0].ossDomainName;
        configureInfos.recordNo = detail.data[0].domainNumber;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.is-vertical {
  height: 100%;
}

.el-aside {
  background-color: #d3dce6;
}

/deep/ .main {
  height: calc(100vh - 104PX);
  background-color: #e9eef3;
  padding: 18PX;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  // @media only screen and (max-width: 1366px) {

  //   overflow-y: auto;
  // }
  // @media only screen and (max-width: 1230px) {
  //   overflow-x: visible;
  // }
}

body > .el-container {
  margin-bottom: 40px;
}
.el-message--error {
  top: 120px !important;
  z-index: 30004 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue